import React from 'react'
//!비디오 임포트 할것

type VideoComponentProps = {
	videoSrc: string
	posterSrc?: string
}

export const VideoComponent: React.FC<VideoComponentProps> = ({ videoSrc, posterSrc }) => {
	return (
		<video width="100%" controls poster={posterSrc}>
			<source src={videoSrc} type="video/mp4" />
		</video>
	)
}
